$(function () {
	/* Navigation Menu */
	$('#nav-menu-toggle').on('click', function (e) {
		var $this = $(this);
		if ($this.hasClass('nav-active')) {
			$this
				.attr('aria-expanded', 'false')
				.add('#nav-menu').removeClass('nav-active');
		} else {
			$this
				.attr('aria-expanded', 'true')
				.add('#nav-menu').addClass('nav-active');
		}
	});

	/* Fix "Skip navigation links" to actually move focus */
	$('body').on('keydown.nav', 'a[href^="#"]', function (e) {
		var $target = $($(this).attr('href'));
		if ((e.keyCode === 13 || e.keyCode === 32) && $target.length) {
			if (!$target.attr('tabindex')) {
				$target.attr('tabindex', '-1').one('blur.nav', function () {
					$target.removeAttr('tabindex');
				});
			}
			$target.focus();
			return false;
		}
	});

	/* Make outlines only appear when using keyboard */
	$('body')
		.on('keydown.accessibility', function (e) {
			if (e.keyCode === 9) {
				$('html').removeClass('mouse');
			}
		})
		.on('mousedown.accessibility', function (e) {
			$('html').addClass('mouse');
		});

	$('#register-trigger, #newsletter-trigger').on('click', function () {
		var email = $('#email-from-sidebar').val();
		if (email) {
			$('#newsletter-email').val(email);
		}
		$('.mc4wp-form').modal();
	});
	if (window.openModal && $('.mc4wp-response:not(:empty)').length) {
		$('.newsletter-form').addClass('hidden');
		$('.newsletter-sidebar .textwidget').html($('.sidebar-success:not(:empty)').html());
		$('.mc4wp-form').modal();
	}
	if (window.location.pathname.indexOf('/page/') === 0) {
		$('#nav-menu a[href="/"]').parent('li').addClass('current-menu-item');
	}
});